import { useContext } from 'react';
import SaladbarContext from './SaladbarContext';

/**
 * ```js
 * const {
 *   enqueueNotification,
 *   enqueueSuccessNotification,
 *   enqueueInfoNotification,
 *   enqueueWarningNotification,
 *   enqueueErrorNotification,
 * } = useSaladBar();
 * ...
 * enqueueNotification({message: 'hello', severity: 'info'});
 * // or
 * enqueueInfoNotification('hello');
 * ```
 *
 * Use the `useSaladBar` hook in components to access the enqueueNotification()
 * method to add a snackbar message to queue.
 */
export default function useSaladBar() {
  return useContext(SaladbarContext);
}
